import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-what-is-log',
  templateUrl: './what-is-log.component.html',
  styleUrls: ['./what-is-log.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class WhatIsLogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/what-is-log/what-is-log.component.ts